<template>
  <v-app-bar app light style="z-index:999">
    <div class="d-flex align-center" @click="home">
      <v-img
        alt="Logo"
        class="shrink mr-0 mr-lg-2"
        contain
        src="../assets/logo.png"
        transition="scale-transition"
        :width="`${isMobile() ? '70' : '100'}`"
      />

      <h2 v-if="!isMobile()">Drell</h2>
    </div>

    <v-spacer v-if="!isMobile()" />

    <v-btn text :class="`${isMobile() ? 'fontMobile' : ''}`" @click="about">
      História
    </v-btn>
    <v-btn text :class="`${isMobile() ? 'fontMobile' : ''}`" @click="product">
      Produtos
    </v-btn>
    <v-btn text :class="`${isMobile() ? 'fontMobile' : ''}`" @click="contact">
      Contato
    </v-btn>
  </v-app-bar>
</template>
<script>
export default {
  methods: {
    contact() {
      this.$router.push({ name: "contact" });
    },
    home() {
      this.$router.push({ name: "home" });
    },
    about() {
      this.$router.push({ name: "about" });
    },
    product() {
      this.$router.push({ name: "products" });
    },
    isMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];
      return toMatch.some(toMatchItem => {
        return navigator.userAgent.match(toMatchItem);
      });
    }
  }
};
</script>
<style>
.fontMobile {
  font-size: 11px !important;
}
</style>
